import { useCallback } from 'react'
import { PropertySuggestion } from '../types'

type UseKeyboardNavigationParams = {
  showSuggestions: boolean
  suggestions: PropertySuggestion[]
  highlightedIndex: number
  setHighlightedIndex: React.Dispatch<React.SetStateAction<number>>
  setSelectedSuggestion: (s: PropertySuggestion | null) => void
  setIsInputFocused: (b: boolean) => void
  handleSuggestionClick: (s: PropertySuggestion) => void
}

export const useKeyboardNavigation = ({
  showSuggestions,
  suggestions,
  highlightedIndex,
  setHighlightedIndex,
  setSelectedSuggestion,
  setIsInputFocused,
  handleSuggestionClick,
}: UseKeyboardNavigationParams) => {
  return useCallback(
    (e: React.KeyboardEvent) => {
      if (!showSuggestions || suggestions.length === 0) return

      switch (e.key) {
        case 'Home':
          e.preventDefault()
          setHighlightedIndex(0)
          break
        case 'End':
          e.preventDefault()
          setHighlightedIndex(suggestions.length - 1)
          break
        case 'Tab':
          if (highlightedIndex >= 0) {
            handleSuggestionClick(suggestions[highlightedIndex])
          }
          break
        case 'ArrowDown':
          e.preventDefault()
          setHighlightedIndex((prev) => (prev + 1) % suggestions.length)
          break
        case 'ArrowUp':
          e.preventDefault()
          setHighlightedIndex((prev) => (prev - 1 + suggestions.length) % suggestions.length)
          break
        case 'Enter':
          e.preventDefault()
          if (highlightedIndex >= 0) {
            handleSuggestionClick(suggestions[highlightedIndex])
          }
          break
        case 'Escape':
          setIsInputFocused(false)
          setHighlightedIndex(-1)
          setSelectedSuggestion(null)
          break
        default:
          break
      }
    },
    [
      showSuggestions,
      suggestions,
      highlightedIndex,
      setHighlightedIndex,
      setSelectedSuggestion,
      setIsInputFocused,
      handleSuggestionClick,
    ],
  )
}
